import React from "react";
import { Link } from "react-router-dom";
import { Smartphone, ArrowRight } from "lucide-react";

const PractidoAppBanner = () => {
  return (
    <div className="w-full relative overflow-hidden rounded-2xl sm:rounded-3xl p-4 sm:p-5 text-white shadow-sm transition-all duration-300 bg-gradient-to-r from-[#d12480] via-[#8527ca] to-[#5040e6]">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
        {/* Left Side: Icon + Heading + Subtitle */}
        <div className="flex items-center gap-3.5 sm:gap-4 w-full sm:w-auto">
          <img
            src="/img/appLogo.png"
            alt="Practido App Logo"
            className="w-11 h-11 sm:w-12 sm:h-12 object-contain rounded-2xl flex-shrink-0 shadow-md"
          />

          <div className="space-y-0.5 text-left">
            <h3 className="text-base sm:text-lg font-bold text-white tracking-tight leading-tight">
              Make Practice a Daily Habit
            </h3>
            <p className="text-xs sm:text-sm text-white/80 font-normal">
              Maths, Science &amp; English practice for Classes 1-12.
            </p>
          </div>
        </div>

        {/* Right Side: Phone Icon + CTA Button */}
        <div className="flex items-center gap-2.5 sm:gap-3 w-full sm:w-auto justify-end">
          <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center flex-shrink-0 shadow-sm">
            <Smartphone className="w-5 h-5 text-[#5040e6]" />
          </div>

          <Link
            to="/olympiad-preparation-apps"
            className="inline-flex items-center justify-center gap-1.5 px-4 sm:px-5 py-2.5 rounded-xl bg-[#5468ff] hover:bg-[#4355f0] active:scale-98 text-white font-bold text-xs sm:text-sm shadow-sm hover:shadow transition-all duration-200 cursor-pointer no-underline whitespace-nowrap"
          >
            <span>Explore Practido App</span>
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PractidoAppBanner;
